import {useDisclosure} from '@mantine/hooks';
import type {FC} from 'react';
import {MdAddCircleOutline} from 'react-icons/md';
import {
  COLOR_PRIMARY,
  COLOR_WHITE,
} from '../../../../../../config/constants/colorCodes';
import {useAuth} from '../../../../../../core/usecases/auth/AuthContext';
import {cn} from '../../../../../../lib/classname';
import {NoLoginAlertModal} from '../../../../../../shared/components/NoLoginAlertModal';
import {formatNumberAsKilo} from '../../../../../../shared/services/formatNumberAsKilo';

type Props = {
  className?: string;
  isFollowing: boolean;
  count: number;
  handleFollowCompany: () => Promise<void>;
  dataGtmContent: string;
};

export const FollowCompanyButtonPresentation: FC<Props> = ({
  className,
  handleFollowCompany,
  isFollowing,
  count,
  dataGtmContent,
}) => {
  const [opened, {open, close}] = useDisclosure(false);
  const {status} = useAuth();

  const onClick = async (e?: React.MouseEvent<HTMLButtonElement>) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (status === 'unauthenticated') {
      open();
      return;
    }

    return handleFollowCompany();
  };

  return (
    <>
      <button
        className={cn(
          'w-[150px] p-8 flex items-center justify-center gap-4 rounded-[20px] border-2 border-primary',
          className,
          {
            'bg-primary text-white': isFollowing,
            'bg-white text-primary': !isFollowing,
          },
        )}
        type="button"
        onClick={onClick}
        data-gtm-click="company-follow"
        data-gtm-content={dataGtmContent}
      >
        <MdAddCircleOutline
          color={isFollowing ? COLOR_WHITE : COLOR_PRIMARY}
          size="16px"
        />
        <span className="font-bold text-base">
          {isFollowing ? 'フォロー中' : 'フォロー'}
        </span>
        <span className="text-sm">{formatNumberAsKilo(count)}</span>
      </button>
      <NoLoginAlertModal opened={opened} onClose={close} />
    </>
  );
};
